import { render } from "./MylastinspectionsView.vue?vue&type=template&id=edf933ec"
import script from "./MylastinspectionsView.vue?vue&type=script&lang=js"
export * from "./MylastinspectionsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__